// import AOS from "aos";
import lozad from "lozad";
import { header } from "./header";
import swiperInit from "./swiper";
import {
	setBackgroundElement,
	ToggleItem,
	detectCloseElement,
	buttonToTop,
	toggleCta,
	clickScrollToDiv,
	appendCaptchaASP,
	toggleBookPin,
} from "./helper";
// import { noUiSliderInit } from "./nouislider";
import { tocInit } from "./tocbot";
import { careerModal } from "./career";
import { toggleFilterMobile } from "./tour";
import productDetailScroll from "./product-detail";
$(document).ready(function () {
	header.init();
	swiperInit();
	buttonToTop();
	toggleCta();
	setBackgroundElement();
	ToggleItem();
	// noUiSliderInit();
	tocInit();
	toggleBookPin();
	careerModal();
	toggleFilterMobile();
	countDownTime();
	expandText();
	datePicker();
	selectTourItem();
	wrapCaptionImg();
	InfinitieScrollPagination();
	initHeightHeader();
	copyLink();
	setTimeout(() => {
		productDetailScroll();
	}, 1500);
	// setTimeout(() => {
	// 	console.log("scroll - 3");
	// 	menuSpyDay();
	// }, 4000);
	filterProductButton();
});
function filterProductButton () {
	$("body").on("click", ".box-button-apply", async function () { 
		// Add loading class to button
		$(this).addClass('loading');
		
		await new Promise(resolve => setTimeout(resolve, 1000));

		// Remove active class from filter box and hide backdrop 
		$('.box-filter').removeClass('active');
		$('.backdrop-filter').fadeOut();
		
		// Scroll to the tour list section with animation
		$('html, body').animate({
			scrollTop: $('.tour-list').offset().top - $(header).height()
		}, 'fast');
		
		// Remove loading class after 1 second
		
	})
}
function expandText () {
	// Variables
	const $expandText = $('.expand-text');
	const $expandButton = $('.expand-text-button');
	const wordLimit = 100;
	const expandText = 'Xem thêm';
	const collapseText = 'Rút gọn';

	// Exit if expand text container doesn't exist
	if (!$expandText.length) return;

	// Find paragraphs within the container
	const $paragraphs = $expandText.find('p');

	// Case 1: No paragraphs found - Remove button, show original content
	if ($paragraphs.length === 0) {
		$expandButton.remove();
		$expandText.show();
		return;
	}

	// Get the first paragraph
	const $firstParagraph = $paragraphs.first();

	// Get text content and split into words (from the first paragraph only for truncation)
	const fullText = $firstParagraph.text();
	const words = fullText.split(/\s+/);

	// Case 2: Only ONE paragraph AND its content is within the word limit - Remove button, show original content
	if ($paragraphs.length === 1 && words.length <= wordLimit) {
		$expandButton.remove();
		$expandText.show();
		return;
	}

	// --- Proceed with truncation logic if: ---
	// - There's more than one paragraph (regardless of first paragraph length)
	// - OR There's one paragraph and it exceeds the word limit

	// Create shortened version based on the first paragraph
	// Use Math.min to handle cases where first paragraph is shorter than wordLimit but there are more paragraphs
	const shortText = words.slice(0, Math.min(words.length, wordLimit)).join(' ') + (words.length > wordLimit ? '...' : '');

	// Create clone with shortened text
	const $cloneDiv = $('<div class="expand-text-clone"></div>');
	const $cloneP = $('<p></p>').text(shortText);
	$cloneDiv.append($cloneP);

	// Initially show clone, hide original
	$expandText.after($cloneDiv);
	$expandText.hide();

	// Handle button click
	$expandButton.on('click', function () {
		const isExpanded = $(this).hasClass('active');

		if (isExpanded) {
			// Collapse
			$expandText.hide();
			$cloneDiv.show();
			$(this).removeClass('active');
			$(this).text(expandText);
		} else {
			// Expand
			$expandText.show();
			$cloneDiv.hide();
			$(this).addClass('active');
			$(this).text(collapseText);
		}
	});

	// Initialize button text
	$expandButton.text(expandText);
}
// function menuSpyDay() {
// 	const $scheduleContent = $(".schedule-content");
// 	const $scheduleItems = $(".schedule-item");
// 	const $scheduleLinks = $(".schedule-date");

// 	if (!$scheduleContent.length || !$scheduleItems.length) return;

// 	// Handle scroll event
// 	$scheduleContent.on('scroll', function() {
// 	  const scrollPosition = $scheduleContent.scrollTop();
// 	  const containerHeight = $scheduleContent.height();

// 	  // Check each section to see if it's in the viewport
// 	  $scheduleItems.each(function(index) {
// 		const $section = $(this);
// 		const sectionTop = $section.position().top;
// 		const sectionHeight = $section.outerHeight();
// 		const sectionBottom = sectionTop + sectionHeight;

// 		// A section is active if scroll position is within its bounds with small buffer
// 		// OR if the section is taller than the viewport and we're somewhere in the middle
// 		if ((scrollPosition < sectionBottom - 20 && scrollPosition >= sectionTop - 20) || 
// 			(sectionHeight > containerHeight && scrollPosition >= sectionTop && scrollPosition < sectionBottom - containerHeight)) {
// 		  $scheduleLinks.removeClass('active');
// 		  $scheduleLinks.eq(index).addClass('active');
// 		  console.log(`Activated section: ${$section.attr('id')}, top: ${sectionTop}, bottom: ${sectionBottom}, scroll: ${scrollPosition}`);
// 		  return false; // Break the each loop once we find a match
// 		}
// 	  });
// 	});

// 	// Handle clicks on navigation links
// 	$scheduleLinks.on("click", function(e) {
// 	  e.preventDefault();
// 	  const index = $(this).index();
// 	  const $targetSection = $scheduleItems.eq(index);

// 	  // Update active state
// 	  $scheduleLinks.removeClass("active");
// 	  $(this).addClass("active");

// 	  // Scroll to section
// 	  $scheduleContent.animate({
// 		scrollTop: $targetSection.position().top
// 	  }, 300);
// 	});

// 	// Initial check to set the correct section on page load
// 	setTimeout(function() {
// 	  $scheduleContent.trigger('scroll');
// 	}, 100);

// 	// Re-check on window resize
// 	$(window).on('resize', function() {
// 	  setTimeout(function() {
// 		$scheduleContent.trigger('scroll');
// 	  }, 100);
// 	});

// 	// Return destroy method
// 	return {
// 	  destroy: function() {
// 		$scheduleContent.off('scroll');
// 		$scheduleLinks.off('click');
// 		$(window).off('resize');
// 	  }
// 	};
//   }
// function menuSpyDay () {
// 	const $scheduleContent = $(".schedule-content");
// 	const $scheduleItems = $(".schedule-item");
// 	const $scheduleLinks = $(".schedule-date");

// 	if (!$scheduleContent.length || !$scheduleItems.length) return;

// 	// Configuration
// 	const threshold = 20; // Adjust this value to control when items activate

// 	// Cache item positions
// 	let scrollItems = [];
// 	let currentItem = null;
// 	let isScrolling = false;
// 	let rafId = null;

// 	// Initialize cached items
// 	function cacheItems () {
// 		scrollItems = [];
// 		$scheduleItems.each(function (index) {
// 			scrollItems.push({
// 				element: $(this),
// 				target: $(this),
// 				link: $scheduleLinks.eq(index),
// 				offset: Math.floor($(this).position().top)
// 			});
// 		});

// 		// Sort by offset
// 		scrollItems.sort((a, b) => a.offset - b.offset);
// 	}

// 	// Handle scroll with requestAnimationFrame for better performance
// 	function onScroll () {
// 		if (!isScrolling) {
// 			isScrolling = true;
// 			rafId = requestAnimationFrame(update);
// 		}
// 	}

// 	// Update active state based on scroll position
// 	function update () {
// 		const scrollTop = $scheduleContent.scrollTop();
// 		const containerHeight = $scheduleContent.height();

// 		// Find items in view
// 		// The threshold helps determine when an item is considered "in view"
// 		const inView = scrollItems.filter(item => {
// 			const itemTop = item.offset;
// 			const itemHeight = item.element.outerHeight();
// 			const itemBottom = itemTop + itemHeight;

// 			// Check if item is in view (partially or fully)
// 			return (itemTop < scrollTop + containerHeight) &&
// 				(itemBottom > scrollTop + threshold);
// 		});

// 		// Get the last item in view (closest to bottom if multiple are in view)
// 		const activeItem = inView.length ? inView[inView.length - 1] : null;

// 		// Update active class if needed
// 		if (activeItem && (!currentItem || activeItem.element[0] !== currentItem.element[0])) {
// 			$scheduleLinks.removeClass("active");
// 			activeItem.link.addClass("active");
// 			currentItem = activeItem;
// 		}

// 		isScrolling = false;
// 	}

// 	// Handle clicks on navigation links
// 	$scheduleLinks.on("click", function (e) {
// 		e.preventDefault();
// 		const index = $(this).index();

// 		$scheduleLinks.removeClass("active");
// 		$(this).addClass("active");

// 		// Get target section and scroll to it
// 		if (scrollItems[index]) {
// 			$scheduleContent.animate({
// 				scrollTop: scrollItems[index].offset
// 			}, 300);
// 		}
// 	});

// 	// Set up event listeners
// 	$scheduleContent.on('scroll', onScroll);

// 	// Initial setup
// 	cacheItems();
// 	update();

// 	// Handle window resize
// 	$(window).on('resize', function () {
// 		cacheItems();
// 		update();
// 	});

// 	// Return destroy method
// 	return {
// 		destroy: function () {
// 			$scheduleContent.off('scroll', onScroll);
// 			if (rafId) cancelAnimationFrame(rafId);
// 		}
// 	};
// }

// function menuSpyDay() {
// 	const $scheduleContent = $(".schedule-content");
// 	const $scheduleItems = $(".schedule-item");
// 	const $scheduleLinks = $(".schedule-date");
// 	let waypoints = [];
// 	$scheduleItems.each(function (index) {
// 		waypoints.push(
// 			new Waypoint({
// 				element: this,
// 				context: $scheduleContent[0],
// 				offset: 100,
// 				handler: function (direction) {
// 					$scheduleLinks.removeClass("active");
// 					if (direction === "down") {
// 						console.log(index);
// 						$scheduleLinks.eq(index).addClass("active");
// 					} else {
// 						console.log(index);
// 						$scheduleLinks.eq(index).addClass("active");
// 					}
// 				},
// 			})
// 		);

// 		$scheduleLinks.eq(index).on("click", function (e) {
// 			// Disable waypoints
// 			waypoints.forEach((wp) => wp.disable());

// 			// Force active state
// 			$(this).addClass("active").siblings().removeClass("active");

// 			// Re-enable waypoints after a short delay
// 			setTimeout(() => {
// 				waypoints.forEach((wp) => wp.enable());
// 			}, 100);
// 		});
// 	});
// }
function copyLink () {
	const $copyLink = $(".copy-link");
	$copyLink.on("click", function (e) {
		e.preventDefault();
		navigator.clipboard.writeText(window.location.href);
		$(this).addClass("active");
		setTimeout(() => {
			$(this).removeClass("active");
		}, 500);
	});
}
function initHeightHeader () {
	const height = $("header").height();
	document.documentElement.style.setProperty(
		"--header-height",
		`${height}px`
	);
}

function InfinitieScrollPagination () {
	const $pager = $(".ModulePager");
	const $container = $(".wrap-item-append");
	const $loadMoreBtn = $(".button-add-more-product");

	// Early return if no pager exists
	if (!$pager.length) {
		$loadMoreBtn.remove();
		return;
	}

	// Initialize infinite scroll
	const infScroll = $container.infiniteScroll({
		// Core options
		path: ".ModulePager",
		append: ".wrap-item-append .news-item",

		// UI elements
		status: ".scroller-status",
		hideNav: ".pagination",
		button: ".button-add-more-items",

		// Behavior
		checkLastPage: ".LastPage",
		history: "push",
		scrollThreshold: false, // Button-triggered loading

		// Performance options
		prefill: false,
		loadOnScroll: false,
		debug: false,
	});

	// Handle successful appends
	infScroll.on("append.infiniteScroll", function (event, body, path, items) {
		$(items).removeClass("is-big");
		// Lazy load new images
		lozad().observe();
	});

	// Handle errors
	infScroll.on("error.infiniteScroll", function (error, path) {
		console.error("Loading error:", path, error);
		$loadMoreBtn.addClass("is-disabled");
	});

	// Handle last page
	infScroll.on("last.infiniteScroll", function () {
		$loadMoreBtn.addClass("is-disabled").prop("disabled", true);
	});
}


function wrapCaptionImg () {
	if (!$(".news-detail-section").length) return;
	$(".full-content img[alt]").each(function () {
		const $this = $(this);
		const $caption = $this.attr("alt");
		if (!$this.parent().is("figure")) {
			$this
				.wrap(`<figure></figure>`)
				.after(`<figcaption>${$caption}</figcaption>`);
		}
	});
}
/*==================== Select ====================*/
function selectTourItem () {
	$(".tour-info-item select").selectmenu({
		change: function (event, ui) {
			const selectedValue = this.value;
			console.log("🚀 ~ selectTourItem ~ selectedValue:", selectedValue);
			window.location.href = selectedValue;
		},
	});
}
/*==================== Date Picker ====================*/
function datePicker () {
	$("#date, .datepicker").datepicker({
		minDate: 0, // This sets the minimum date to today
		dateFormat: "yy-mm-dd",
		beforeShowDay: function (date) {
			var today = new Date();
			today.setHours(0, 0, 0, 0);
			return [date >= today, ""];
		},
	});
}
/*==================== Expand Text ====================*/
// function expandText () {
// 	$("p:has(a.text-blue-600)").each(function () {
// 		const $p = $(this);
// 		const $expandLink = $p.find("a.text-blue-600").eq(0);
// 		const $collapseLink = $p.find("a.text-blue-600").eq(1);
// 		const fullText = $p.clone().children().remove().end().text().trim();
// 		const words = fullText.split(/\s+/);

// 		if (words.length > 70) {
// 			const shortText = words.slice(0, 70).join(" ") + "... ";

// 			function toggleText (e) {
// 				e.preventDefault();
// 				const isExpanded = $p.data("expanded");
// 				if (isExpanded) {
// 					$p.html(shortText);
// 					$p.append($expandLink).append($collapseLink);
// 					$expandLink.show();
// 					$collapseLink.hide();
// 				} else {
// 					$p.html(fullText);
// 					$p.append($expandLink).append($collapseLink);
// 					$expandLink.hide();
// 					$collapseLink.show();
// 				}
// 				$p.data("expanded", !isExpanded);
// 			}

// 			$p.html(shortText);
// 			$p.append($expandLink).append($collapseLink);
// 			$collapseLink.hide();

// 			$expandLink.on("click", toggleText);
// 			$collapseLink.on("click", toggleText);

// 			$p.data("expanded", false);
// 		} else {
// 			$expandLink.hide();
// 			$collapseLink.hide();
// 		}
// 	});
// }
/*==================== Count Down Time ====================*/
function countDownTime () {
	$(".count-down").each(function () {
		const $this = $(this);
		const $span = $this.find("span").first();
		const timeString = $span.text();
		const [hours, minutes, seconds] = timeString.split(":").map(Number);

		let totalSeconds = hours * 3600 + minutes * 60 + seconds;

		const timer = setInterval(() => {
			totalSeconds--;

			if (totalSeconds <= 0) {
				clearInterval(timer);
				$this.text("Expired");
			} else {
				const h = Math.floor(totalSeconds / 3600);
				const m = Math.floor((totalSeconds % 3600) / 60);
				const s = totalSeconds % 60;

				$span.text(
					`${h.toString().padStart(2, "0")}:${m
						.toString()
						.padStart(2, "0")}:${s.toString().padStart(2, "0")}`
				);
			}
		}, 1000);
	});
}

/*==================== Aos Init ====================*/
// AOS.init({
// 	offset: 100,
// });
/*==================== Lazyload JS ====================*/
const observer = lozad(); // lazy loads elements with default selector as '.lozad'
window.lozad = observer;
const backgroundObserver = lozad(".lozad-bg", {
	threshold: 0.1,
});
observer.observe();
backgroundObserver.observe();

